import {WlDropdown} from "./dropdown.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './dropdown.component';
export default WlDropdown;

defineWebComponent('wl-dropdown', WlDropdown);